/* eslint-disable @typescript-eslint/no-shadow */
import { Button, Form, Input, Modal } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { DeleteModal, IconFont, SignTitle } from '@/components'
import { Scrollbars } from 'react-custom-scrollbars'
import styled from 'styled-components'
import { useDeltetName, usePostName, usePutContactsTag } from './utils'
import { useUnmountedRef } from 'ahooks'
import { t } from '@/i18n'
const { useForm } = Form
export const LabelManagement = (props: {
  visible: boolean
  close: (data: boolean) => void
  getTagList: any[]
  tagList: () => void
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { visible, close, getTagList, tagList } = props
  const [form] = useForm()
  const [deltetName, deleteLoad] = useDeltetName()
  const [postName] = usePostName()
  const [putContactsTag, putContactsTagLoad] = usePutContactsTag()
  const [newData, setNewData] = useState({ show: true, name: '' })
  const [deleteModal, setDeleteModal] = useState({ visible: false, id: null })
  useEffect(() => {
    setIsModalVisible(visible)
  }, [visible])
  let [valueList, setValueList] = useState<any>({})
  useEffect(() => {
    let arr = {}
    getTagList?.map(item => {
      arr[`item${item.id}`] = item.name
    })
    setValueList(arr)
  }, [getTagList])

  const deleteEmailHandler = async id => {
    try {
      await deltetName({ id: id })
      await tagList()
      setDeleteModal({ visible: false, id: null })
    } catch (err) {}
  }
  const handleOk = () => {
    form.submit()
  }
  const handleCancel = () => {
    close(false)
    form.resetFields()
    setNewList([''])
    setNewData({ show: true, name: '' })
    setSelectGroup({ id: null })
  }
  let [selectGroup, setSelectGroup] = useState<any>({ id: null })
  const isUnMount = useUnmountedRef()
  const inputContentRef = useRef('')
  const [loading, setLoding] = useState<'cancel' | 'ok' | ''>('')
  let [newList, setNewList] = useState([''])
  const cancelHandler = async () => {
    if (loading) return
    try {
      setLoding('cancel')
      setValueList(origin => ({ ...origin, [`item${selectGroup.id}`]: inputContentRef.current }))
      setSelectGroup({ id: null })
      setNewData({ show: false, name: '' })
      setNewList([])
    } catch (e) {
    } finally {
      if (!isUnMount.current) {
        setLoding('')
      }
    }
  }
  const okHandler = async () => {
    if (loading) return
    try {
      if (!newData.show) {
        await putContactsTag({ id: selectGroup.id, name: valueList[`item${selectGroup.id}`] })
        await tagList()
        setSelectGroup({ id: null })
      } else {
        await postName({ name_list: [newData.name] })
        await tagList()
        setNewList([])
        setNewData({ show: false, name: '' })
      }
      if (putContactsTagLoad) {
        setLoding('ok')
      }
    } catch (e) {
    } finally {
      if (!isUnMount.current) {
        setLoding('')
      }
    }
  }
  return (
    <Modal
      title={<SignTitle show>{t('标签管理')}</SignTitle>}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[]}
      centered
    >
      <FormLists form={form}>
        <ListItem>
          {getTagList?.map(
            items =>
              items?.origin_type === 2 && (
                <Form.Item
                  key={items?.id}
                  name={`item${items.id}`}
                  rules={[
                    { required: true, message: t('请输入标签') },
                    {
                      validator(_, name) {
                        if (getTagList?.some(item => item?.name === name)) {
                          return Promise.reject(new Error(t('标签已存在')))
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  style={{ marginBottom: 10 }}
                >
                  <GroupItemContainer>
                    <Input
                      disabled={selectGroup.id !== items.id}
                      bordered={selectGroup.id === items.id}
                      onChange={e => {
                        setValueList(origin => ({ ...origin, [`item${items.id}`]: e.target.value }))
                      }}
                      onFocus={e => (inputContentRef.current = e.target.value)}
                      value={valueList[`item${items.id}`]}
                      placeholder={t('请输入标签名称')}
                    />

                    {selectGroup.id !== items.id ? (
                      <>
                        <IconFont
                          style={{ cursor: 'pointer', margin: '0 10px', fontSize: '16px' }}
                          type={'icon-huabanfuben'}
                          className="delete-icon"
                          onClick={() => {
                            inputContentRef.current = items.name
                            setSelectGroup({ id: items.id })
                            setNewList([])
                            setNewData({ show: false, name: '' })
                          }}
                        />

                        <IconFont
                          type={'icon-shanchu-m'}
                          className="delete-icon"
                          onClick={() => {
                            setNewList([])
                            deleteEmailHandler(items?.id)
                            setNewData({ show: false, name: '' })
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <CloseCircleOutlined
                          className="icon"
                          onClick={cancelHandler}
                          style={{ cursor: 'pointer', margin: '0 10px' }}
                        />

                        <CheckCircleOutlined
                          className="icon"
                          onClick={() => {
                            okHandler()
                          }}
                        />
                      </>
                    )}
                  </GroupItemContainer>
                </Form.Item>
              ),
          )}
          {newList?.map((item, index) => (
            <Form.Item
              key={index}
              name={index}
              rules={[
                { required: true, message: t('请输入标签') },
                {
                  validator(_, name) {
                    if (getTagList?.some(item => item.name === name)) {
                      return Promise.reject(new Error(t('标签已存在')))
                    }
                    return Promise.resolve()
                  },
                },
              ]}
              style={{ marginBottom: 10 }}
            >
              <GroupItemContainer>
                <Input
                  onFocus={e => (inputContentRef.current = e.target.value)}
                  placeholder={t('请输入标签名称')}
                  onChange={e => {
                    setNewData({ show: true, name: e.target.value })
                  }}
                  value={newData.name}
                />

                {!newData.show ? (
                  <>
                    <IconFont
                      style={{ cursor: 'pointer', marginRight: '10px', fontSize: '16px' }}
                      type={'icon-huabanfuben'}
                      className="delete-icon"
                    />

                    <IconFont type={'icon-shanchu-m'} className="delete-icon" />
                  </>
                ) : (
                  <>
                    <CloseCircleOutlined
                      className="icon"
                      onClick={cancelHandler}
                      style={{ cursor: 'pointer', margin: '0 10px' }}
                    />

                    <CheckCircleOutlined
                      className="icon"
                      onClick={() => {
                        okHandler()
                      }}
                    />
                  </>
                )}
              </GroupItemContainer>
            </Form.Item>
          ))}
        </ListItem>
        <div className="add">
          <div
            style={{ width: 60, cursor: 'pointer' }}
            onClick={() => {
              if (!newData.show) {
                setValueList(origin => ({
                  ...origin,
                  [`item${selectGroup.id}`]: inputContentRef.current,
                }))
                setNewList(origin => [...origin, ''])
                setNewData({ show: true, name: '' })
                setSelectGroup({ id: null })
              }
            }}
          >
            <IconFont type="icon-zengjia" /> {t('添加')}
          </div>
        </div>
      </FormLists>
      <DeleteModal
        confirmLoading={deleteLoad}
        onOk={deleteEmailHandler}
        onCancel={() => {
          setDeleteModal({ visible: false, id: null })
        }}
        visible={deleteModal.visible}
        text={t('此操作将永久删除,是否继续?')}
      />
    </Modal>
  )
}
interface GroupItemContainerProps {
  isActive: boolean
}

const GroupItemContainer = styled.div<GroupItemContainerProps>`
  height: 32px;
  border-radius: 4px;
  padding-left: 15px;
  padding-right: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  .delete-icon,
  .icon {
    color: #999;
    &:hover {
      color: #4238c9;
    }
  }
  .text {
    line-height: 1.5;
    padding-left: 10px;
    flex-grow: 1;
    width: 0;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #fff;
    border-radius: 6px;
  }
  .ant-input[disabled] {
    background: #fff;
    color: #333;
    cursor: pointer;
  }
`
const FormLists = styled(Form)`
  width: 449px;
  height: 300px;
  background: #f7f8f9;
  border-radius: 6px;
  padding-top: 4px;
  padding: 12px 0;
  .ant-form-item {
    margin: 0;
  }
  .ant-space-item {
    width: 100%;
    margin-bottom: 16px !important;
  }
  .add {
    width: 100%;
    padding: 12px;
    border-top: 1px solid #eaedf1;
  }
`
const ListItem = styled.div`
  height: 250px;
  overflow-y: auto;
`
